module.exports = __webpack_public_path__ + "img/back-icon.bde003b2.svg";